import React from "react";
import Collapse from "@mui/material/Collapse";
export const DATA_ATTRIBUTE_NOTIFICATION_ID = "data-notification-id";
export const CLEAN_UP_NOTIFICATION_CUSTOM_EVENT_NAME = "CLEAN_UP_NOTIFICATION_CUSTOM_EVENT_NAME";
export const DEFAULT_NOTIFICATION_ANIMATION_DURATION_IN_SECONDS = {
    enter: 800,
    exit: 800,
};
export const Animation = ({ notificationId, status, children, animationDuration = DEFAULT_NOTIFICATION_ANIMATION_DURATION_IN_SECONDS, }) => {
    const dataAttributes = {
        [DATA_ATTRIBUTE_NOTIFICATION_ID]: notificationId,
    };
    return (React.createElement(Collapse, { ...dataAttributes, "data-name": "animation-wrapper", "data-id": notificationId, in: status === "SHOW", timeout: animationDuration }, children));
};
//# sourceMappingURL=Animation.js.map